<template>
    <div class="product-list-page">
        <div class="desktop-page" v-if="!this.GLOBAL.isMobile">
            <div class="wrap">
                <section class="page-head">
                    <div class="tabs category-tabs">
                        <button
                            v-for="productType in productTypeList"
                            :key="productType.id"
                            type="button"
                            :class="{ active: isActiveType(productType.id) }"
                            @click="goProductType(productType.id)"
                        >
                            {{ productType.name }}
                        </button>
                    </div>
                    <div class="search-row">
                        <div class="search-box">
                            <el-input
                                v-model="searchValue"
                                :placeholder="$t('text1')"
                                class="product-search"
                                @keyup.enter.native="handleSearch"
                            >
                                <button slot="suffix" type="button" class="search-trigger" @click="handleSearch">
                                    <i class="el-icon-search"></i>
                                </button>
                            </el-input>
                        </div>
                    </div>
                </section>

                <section class="product-grid-section">
                    <div class="product-grid">
                        <article v-for="product in productPageList" :key="product.id" class="product-card">
                            <a class="product-link" :href="'#/productDetail?id=' + product.id">
                                <div class="product-image-wrap">
                                    <img
                                        class="product-image"
                                        :src="cp + '/jyy/billFile/getFile?uuid=' + product.showPicUuid"
                                        :alt="product.productName"
                                    />
                                </div>
                                <div class="product-copy">
                                    <h2 class="product-title">{{ product.productName }} {{ product.productSpec }}</h2>
                                    <p class="product-subtitle">{{ product.showTitle }}</p>
                                </div>
                            </a>
                        </article>
                    </div>
                </section>

                <div class="pagination-wrap">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-size="pageSize"
                        :pager-count="11"
                        layout="prev, pager, next"
                        :total="total"
                    ></el-pagination>
                </div>

                <section class="contact-strip">
                    <div class="contact-copy">
                        <h3>{{ $t('index_23') }}</h3>
                        <p>
                            {{ $t('index_24_1') }}<br>
                            {{ $t('index_25_1') }}<br>
                            {{ $t('index_27_1') }}
                            <a target="_blank" rel="noopener" href="https://www.amap.com/ssr/search?query=北京市昌平区沙河新飞达科技发展中心F6-3">
                                {{ $t('index_28_1') }}
                            </a>
                        </p>
                    </div>
                    <a href="#/item" class="more">{{ $t('text3') }}</a>
                </section>
            </div>
        </div>

        <div id="productListDiv" class="mobile-page" v-if="this.GLOBAL.isMobile" @touchmove="isShow">
            <div class="wrap">
                <section class="page-head mobile-head">
                    <div class="search-box mobile-search-box">
                        <el-input
                            v-model="searchValue"
                            :placeholder="$t('text1')"
                            class="product-search"
                            @keyup.enter.native="handleSearch"
                        >
                            <button slot="suffix" type="button" class="search-trigger" @click="handleSearch">
                                <i class="el-icon-search"></i>
                            </button>
                        </el-input>
                    </div>
                    <div class="tabs category-tabs mobile-tabs">
                        <button
                            v-for="productType in productTypeList"
                            :key="productType.id"
                            type="button"
                            :class="{ active: isActiveType(productType.id) }"
                            @click="goProductType(productType.id)"
                        >
                            {{ productType.name }}
                        </button>
                    </div>
                </section>

                <section class="mobile-grid">
                    <article v-for="product in productPageList" :key="product.id" class="mobile-card">
                        <a class="product-link" :href="'#/productDetail?id=' + product.id">
                            <div class="product-image-wrap mobile-image-wrap">
                                <img
                                    class="product-image"
                                    :src="cp + '/jyy/billFile/getFile?uuid=' + product.showPicUuid"
                                    :alt="product.productName"
                                />
                            </div>
                            <div class="product-copy mobile-copy">
                                <div class="product-title mobile-title">{{ product.productName }} {{ product.productSpec }}</div>
                                <div class="product-subtitle mobile-subtitle">{{ product.showTitle }}</div>
                            </div>
                        </a>
                    </article>
                </section>

                <div id="getMoreDiv" class="load-more-wrap">
                    <div v-if="total > page * pageSize" class="load-more" @click="getMore">{{ $t('text2') }}</div>
                </div>

                <section class="contact-strip mobile-contact">
                    <div class="contact-copy">
                        <h3>{{ $t('index_23') }}</h3>
                        <p>
                            {{ $t('index_24_1') }}<br>
                            {{ $t('index_25_1') }}<br>
                            {{ $t('index_27_1') }}
                            <a target="_blank" rel="noopener" href="https://www.amap.com/ssr/search?query=北京市昌平区沙河新飞达科技发展中心F6-3">
                                {{ $t('index_28_1') }}
                            </a>
                        </p>
                    </div>
                    <a href="#/item" class="more">{{ $t('text3') }}</a>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import {getPageParamStr, getParam} from '@/utils/utils'
import axios from '@/utils/axios'

export default {
    data() {
        return {
            cp: this.GLOBAL.cp,
            page: 1,
            pageSize: 8,
            total: 0,
            searchValue: '',
            goodsType: '',
            productTypeList: [],
            productPageList: [],
            loading: false,
        }
    },
    watch: {
        $route() {
            this.goodsType = getParam('type') || ''
            this.page = 1
            this.productPageList = []
            this.initPageList()
        },
    },
    mounted() {
        this.goodsType = getParam('type') || ''
        axios.get('/jyy/portal/getProductTypeList')
            .then(res => {
                this.productTypeList = res.data
                this.initPageList()
            })
    },
    methods: {
        isActiveType(typeId) {
            return String(this.goodsType || '') === String(typeId || '')
        },
        goProductType(typeId) {
            if (this.isActiveType(typeId)) {
                this.page = 1
                this.productPageList = []
                this.initPageList()
                return
            }
            this.$router.push({path: '/productList', query: {type: typeId}})
        },
        handleSearch() {
            this.page = 1
            this.productPageList = []
            this.initPageList()
        },
        initPageList() {
            this.loading = true
            const searchValue = encodeURIComponent(this.searchValue)
            const url = '/jyy/portal/selectProductPage?searchValue=' + searchValue +
                '&goodsType=' + this.goodsType +
                getPageParamStr(this.page, this.pageSize)
            axios.get(url).then(res => {
                this.page = res.data.page
                this.pageSize = res.data.pageSize
                this.total = res.data.total
                if (this.GLOBAL.isMobile && this.page > 1) {
                    this.productPageList = this.productPageList.concat(res.data.rows)
                } else {
                    this.productPageList = res.data.rows
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.page = 1
            this.initPageList()
        },
        handleCurrentChange(val) {
            this.page = val
            this.initPageList()
        },
        getMore() {
            if (this.loading || this.total <= this.page * this.pageSize) {
                return
            }
            this.page = this.page + 1
            this.initPageList()
        },
        isShow() {
            const element = document.getElementById('getMoreDiv')
            if (!element) {
                return
            }
            const innerHeight = window.innerHeight
            const clientHeight = element.clientHeight
            const {top} = element.getBoundingClientRect()
            if (top < innerHeight - clientHeight + 100 && !this.loading && this.total > this.page * this.pageSize) {
                this.page = this.page + 1
                this.initPageList()
            }
        },
    },
}
</script>

<style scoped>
.product-list-page {
    min-height: 800px;
    background: linear-gradient(180deg, #f9fbff 0%, #f4f8fe 100%);
    color: #111c2d;
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.wrap {
    width: min(1200px, calc(100% - 40px));
    margin: 0 auto;
}

.desktop-page {
    padding: 72px 0 64px;
}

.mobile-page {
    padding: 76px 0 44px;
}

.page-head {
    padding-bottom: 6px;
}

.tabs {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0;
}

.tabs button {
    position: relative;
    min-height: 44px;
    padding: 0 24px 12px;
    border: none;
    border-radius: 0;
    background: transparent;
    color: #8a9ab0;
    font-size: 15px;
    font-weight: 400;
    cursor: pointer;
    transition: color 0.22s ease;
}

.tabs button::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 0;
    height: 3px;
    background: linear-gradient(90deg, #09aeff 0%, #72f7b1 100%);
    transition: width 0.2s linear;
}

.tabs button:hover,
.tabs button.active {
    color: #0a3569;
    font-weight: 600;
}

.tabs button:hover::after,
.tabs button.active::after {
    width: 100%;
}

.category-tabs {
    padding-bottom: 18px;
    border-bottom: 1px solid #dbe4ef;
}

.search-row {
    padding-top: 18px;
}

.search-box {
    display: flex;
    justify-content: flex-end;
}

.product-search {
    width: 260px;
    max-width: 100%;
}

.product-search ::v-deep .el-input__inner {
    height: 40px;
    padding-left: 14px;
    padding-right: 42px;
    border: 1px solid #d1dbe8;
    border-radius: 8px;
    background: #ffffff;
    color: #111c2d;
    transition: border-color 0.22s ease, box-shadow 0.22s ease;
}

.product-search ::v-deep .el-input__inner:focus {
    border-color: #0a3569;
    box-shadow: 0 0 0 3px rgba(10, 53, 105, 0.08);
}

.product-search ::v-deep .el-input__suffix {
    right: 8px;
    display: flex;
    align-items: center;
    height: 100%;
}

.product-search ::v-deep .el-input__suffix-inner {
    display: flex;
    align-items: center;
}

.search-trigger {
    width: 26px;
    height: 26px;
    padding: 0;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: #0a3569;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.22s ease, color 0.22s ease;
}

.search-trigger:hover {
    background: rgba(10, 53, 105, 0.08);
}

.product-grid-section {
    padding-top: 34px;
}

.product-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 24px;
}

.product-link {
    display: block;
    height: 100%;
    text-decoration: none;
    color: inherit;
    border-radius: 12px;
    background: #ffffff;
    box-shadow: 0 6px 18px rgba(14, 47, 94, 0.06);
    transition: transform 0.22s ease, box-shadow 0.22s ease;
}

.product-link:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(14, 47, 94, 0.1);
}

.product-image-wrap {
    height: 240px;
    padding: 24px;
    display: flex;
    border-radius: 12px 12px 0 0;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg, #eef4fb 0%, #e4edf7 100%);
}

.product-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.product-copy {
    padding: 18px 18px 20px;
}

.product-title {
    margin: 0 0 10px;
    color: #111c2d;
    font-size: 18px;
    font-weight: 600;
    line-height: 1.5;
    min-height: 54px;
}

.product-subtitle {
    margin: 0;
    color: #5c6575;
    font-size: 14px;
    line-height: 1.8;
    min-height: 50px;
}

.pagination-wrap {
    padding-top: 34px;
    text-align: center;
}

.pagination-wrap ::v-deep .btn-prev,
.pagination-wrap ::v-deep .btn-next,
.pagination-wrap ::v-deep .el-pager li {
    min-width: 34px;
    height: 34px;
    line-height: 34px;
    border: none;
    background: transparent;
    color: #8a9ab0;
    font-weight: 400;
}

.pagination-wrap ::v-deep .el-pager li.active,
.pagination-wrap ::v-deep .btn-prev:hover,
.pagination-wrap ::v-deep .btn-next:hover,
.pagination-wrap ::v-deep .el-pager li:hover {
    color: #0a3569;
    font-weight: 600;
}

.contact-strip {
    margin-top: 42px;
    padding-top: 24px;
    border-top: 1px solid #dbe4ef;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
}

.contact-copy h3 {
    margin: 0 0 10px;
    font-size: 20px;
    font-weight: 600;
    color: #111c2d;
}

.contact-copy p {
    margin: 0;
    color: #5c6575;
    font-size: 14px;
    line-height: 1.9;
}

.contact-copy a {
    color: #0a3569;
    text-decoration: none;
}

.more {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 42px;
    padding: 0 22px;
    border-radius: 8px;
    border: 1px solid rgba(24, 77, 147, 0.25);
    color: #184d93;
    text-decoration: none;
    font-size: 15px;
    font-weight: 600;
    transition: all 0.22s ease;
    white-space: nowrap;
}

.more:hover {
    background: #184d93;
    border-color: #184d93;
    color: #ffffff;
}

.mobile-head {
    padding-bottom: 18px;
}

.mobile-search-box {
    justify-content: stretch;
    margin-bottom: 14px;
}

.mobile-search-box .product-search {
    width: 100%;
}

.mobile-tabs {
    justify-content: flex-start;
}

.mobile-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
    padding-top: 24px;
}

.mobile-image-wrap {
    height: 36vw;
    min-height: 152px;
    padding: 16px;
}

.mobile-copy {
    padding: 14px 14px 16px;
}

.mobile-title {
    font-size: 16px;
    min-height: 48px;
}

.mobile-subtitle {
    min-height: 44px;
    font-size: 13px;
    line-height: 1.7;
}

.load-more-wrap {
    padding-top: 22px;
}

.load-more {
    min-height: 42px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 18px;
    border: 1px solid #d1dbe8;
    border-radius: 8px;
    color: #0a3569;
    font-size: 14px;
    font-weight: 600;
    background: #ffffff;
}

.mobile-contact {
    align-items: flex-start;
    flex-direction: column;
}

@media (max-width: 1180px) {
    .search-box {
        justify-content: center;
    }

    .product-grid {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
}

@media (max-width: 860px) {
    .product-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 640px) {
    .wrap {
        width: calc(100% - 24px);
    }

    .tabs button {
        padding: 0 16px 10px;
        font-size: 14px;
    }

    .mobile-grid {
        gap: 12px;
    }

    .contact-strip {
        gap: 16px;
    }
}
</style>
